<template>
  <div class="registe">
    <div class="top container">
      <router-link to="/">
        <img src="@/assets/images/logo.png" class="logo" alt />
      </router-link>
      <div class="split-line mx-3"></div>
      <span class="title">新用户注册</span>
    </div>
    <div class="content">
      <div class="box">
        <h3 class="title">注册</h3>
        <form action>
          <input
            type="text"
            v-model="accountName"
            name="accountName"
            placeholder="账号名称"
          />
          <input type="text" v-model="name" name="name" placeholder="姓名" />
          <input
            type="text"
            v-model="phone"
            name="phone"
            placeholder="联系电话"
          />
          <input
            type="text"
            v-model="email"
            name="email"
            placeholder="电子邮箱"
          />
          <input
            type="password"
            v-model="password"
            name="password"
            placeholder="密码"
          />
          <input
            type="text"
            v-model="address"
            name="address"
            placeholder="联系地址"
          />
          <input
            type="text"
            v-model="companyName"
            name="companyName"
            placeholder="公司名称"
          />
          <div class="agreement">
            <input
              type="checkbox"
              id="agreement"
              class="mr-2"
              v-model="checked"
            />
            <label for="agreement">
              <span class="text">我已阅读</span>
            </label>
            <span class="link" @click="showModal">《中易网用户注册协议》</span>
          </div>
          <button class="submit-button" @click.stop.prevent="registe">
            提交
          </button>
        </form>
      </div>
    </div>
    <footer class="auth-footer px-2 mx-md-0">
      <p class="copyright">
        COPYRIGHT © 2002-2019 333F.COM.INC.ALL RIGHTS RESERVED.粤ICP备10217460号
      </p>
      <div class="share-link-block">
        <a class="link mr-3" href="http://www.333f.com/" target="_blank"
          >广州市三川田文化科技股份有限公司</a
        >
        <a class="link" href="#" target="_blank">广州小包子数据科技有限公司</a>
      </div>
    </footer>
    <agreement-modal ref="agreementModal"></agreement-modal>
  </div>
</template>
<style lang="scss" scoped>
.registe {
  .top {
    height: 10rem;
    display: flex;
    align-items: center;
    .split-line {
      background-color: #ccc;
      width: 0.13rem;
      height: 3rem;
    }
    .title {
      font-size: 1.63rem;
      color: #666666;
    }
  }
  .content {
    height: 48rem;
    width: 100%;
    background-image: url(../assets/images/auth_bg.png);
    background-size: cover;
    background-repeat: no-repeat;
    background-position: right;
    position: relative;
    .box {
      background-color: #e6eaf3;
      padding: 2rem 2.5rem;
      max-width: 28.44rem;
      width: 90%;
      position: absolute;
      top: 5%;
      // right: 24rem;
      right: 5%;
      input[type='text'],
      input[type='password'] {
        display: block;
        margin-bottom: 1.25rem;
        width: 100%;
        height: 2.88rem;
        background-color: #ffffff;
        border-radius: 0.25rem;
        border: solid 0.06rem #cccccc;
        outline: none;
        font-size: 0.88rem;
        padding-left: 0.63rem;
        &::placeholder {
          color: #999999;
        }
      }
      .agreement {
        margin-bottom: 1.2rem;
        .text {
          font-size: 0.88rem;
          color: #999999;
        }
        .link {
          color: $acentColor;
          &:hover {
            cursor: pointer;
          }
        }
      }
      .submit-button {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 2.88rem;
        color: white;
        background-color: $acentColor;
        outline: none;
        border: none;
      }
    }
  }
  .auth-footer {
    height: 9.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    .copyright {
      color: #333;
      font-size: 0.75rem;
    }
    .share-link-block {
      text-align: center;
      .link {
        font-size: 0.88rem;
        color: #333;
        text-decoration: underline;
        white-space: nowrap;
      }
    }
  }
}
</style>

<script>
import AgreementModal from '@/components/AgreementModal';
import ApiService from '@/common/api.service';
import qs from 'qs';
import { mapMutations } from 'vuex';
export default {
  created() {
    this.setAuth(true);
  },
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      address: '',
      accountName: '',
      companyName: '',
      password: '',
      checked: false
    };
  },
  methods: {
    showModal() {
      this.$refs.agreementModal.show();
    },
    registe() {
      if (!this.checked) {
        window.alert('同意注册协议才能注册');
        return;
      }

      let data = {
        name: this.name,
        accountName: this.accountName,
        company: this.company,
        email: this.email,
        phone: this.phone,
        address: this.address,
        password: this.password,
        companyName: this.companyName
      };
      ApiService.post('/login/register.htm', qs.stringify(data))
        .then(() => this.$router.push('/login'))
        .catch(() => {
          this.$router.push('/login');
        });
    },
    ...mapMutations(['setAuth'])
  },
  components: {
    AgreementModal
  }
};
</script>
